import { Color } from '../../features/visual-analytics/helpers/colors';
import { TpRenderBitmap } from './renderBitmap';
import { TpRenderColoredPoints } from './renderColoredPoints';
import { TpRenderColoredTriangles } from './renderColoredTriangles';
import { TpRenderSimpleLines } from './renderSimpleLines';

// Different types of renderers, to be combined in a layered mode
export enum WebGL2DRenderTypes {
  COLORED_POINTS,
  COLORED_TRIANGLES,
  SIMPLELINES,
  BITMAP,
}

export interface TpWebGl2DProgramContext {
  program: any;
  locZoomFactor: any;
  locPanOffset: any;
  locAttribPosition: any;
  locAttribColor: any;
  locAttribTexCoord?: any;
  locAttribNormal?: any;
  locPointSize?: any;
  locWeight?: any;
  locFixedColor?: any;
  locFixedOpacity?: any;
}

export type TpWebGL2DRenderLayer =
  | TpRenderColoredPoints
  | TpRenderSimpleLines
  | TpRenderColoredTriangles
  | TpRenderBitmap;

// Used to define the viewport along the X and Y axis sMin & sMax represent the minimum & maximum logical coordinate value visible in the viewport
export interface TpWebGl2DScale {
  sMin: number;
  sMax: number;
}

export interface TpWebGl2DContext {
  canvas: any;
  gl: any;
  backColor: Color;
  programContextColoredPoints: TpWebGl2DProgramContext;
  programContextSimpleLines: TpWebGl2DProgramContext;
  programContextColoredTriangles: TpWebGl2DProgramContext;
  programContextBitmap: TpWebGl2DProgramContext;
  renderLayers: TpWebGL2DRenderLayer[];
  scaleX: TpWebGl2DScale;
  scaleY: TpWebGl2DScale;
  pixelRatio: number; // conversion rate of canvas to device pixels
  zoomFactor: number; // 1=no zooming; can be used to e.g. increase point sizes a bit when zooming
}
